import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  SmartActionAccuracy,
  SmartActionsGuard,
} from "@/features/office/smart-actions";
import { maskSearchFragment } from "@/features/shared/route-masking";

const accuracySearchSchema = z.object({
  /** The trailing window in days; the feature narrows it to the offered windows. */
  windowDays: z.coerce.number().int().optional().catch(undefined),
  ...maskSearchFragment,
});

export const routeId = "/office/smart-actions/accuracy";

export const Route = createFileRoute("/office/smart-actions/accuracy")({
  validateSearch: accuracySearchSchema,
  component: SmartActionAccuracyRoute,
});

/** Behind the same gate and role as the board, deep link included. */
function SmartActionAccuracyRoute() {
  return (
    <SmartActionsGuard>
      <SmartActionAccuracy />
    </SmartActionsGuard>
  );
}
